import store from '../store/index'

//----------------------------------------------
// create character artefact items (Item + link)
//----------------------------------------------
export default async function useCreateCharacterArtefactItemsHarness(changed_items) {
  console.log('-----------------------------------------------')
  console.log('IN useCreateCharacterArtefactItemsHarness')
  if (!Array.isArray(changed_items) || changed_items.length === 0) {
    return []
  }

  const this_store = store

  const promises = changed_items.map((entry) => {
    console.log('PROCESSING ARTEFACT ENTRY:', entry)
    const payload = entry.payload || {}
    const formData = new FormData()

    console.log(
      '[RECOVERABLE_ARTEFACT_TRACE] useCreateCharacterArtefactItemsHarness preparing FormData',
      {
        name: entry?.name ?? null,
        trace_id: payload?.id ?? null,
        item_ref: payload?.item ?? null,
        artefact_mode: payload?.artefact_mode ?? null,
        runes_count: Array.isArray(payload?.runes) ? payload.runes.length : 0,
        spells_count: Array.isArray(payload?.spells) ? payload.spells.length : 0,
      },
    )

    // ------------------------------
    // static item (artefact) fields
    // ------------------------------

    if (payload.image_file instanceof FormData) {
      const file = payload.image_file.get('image')
      if (file instanceof File) {
        formData.append('image', file)
      }
    }

    const itemName = payload.item_name || entry.name || ''
    if (itemName) formData.set('name', itemName)

    // enforce artefact type on Item.type
    formData.set('type', payload.item_type || 'Artefact')

    if (payload.artefact_type) formData.set('artefact_type', payload.artefact_type)
    if (payload.artefact_base_item) {
      formData.set('artefact_base_item', payload.artefact_base_item)
    }
    if (payload.trait) formData.set('trait', payload.trait)
    if (payload.enc !== undefined && payload.enc !== null) formData.set('enc', payload.enc)
    if (payload.pwr_storage !== undefined && payload.pwr_storage !== null) {
      formData.set('pwr_storage', payload.pwr_storage)
    }

    if (payload.value_lower !== undefined && payload.value_lower !== null) {
      formData.set('value_lower', payload.value_lower)
    }
    if (payload.value_upper !== undefined && payload.value_upper !== null) {
      formData.set('value_upper', payload.value_upper)
    }
    if (payload.currency) formData.set('currency', payload.currency)
    if (payload.race) formData.set('race', payload.race)
    if (payload.estimated_value !== undefined && payload.estimated_value !== null) {
      formData.set('estimated_value', payload.estimated_value)
    }

    if (payload.age) formData.set('age', payload.age)
    if (payload.quality) formData.set('quality', payload.quality)
    if (payload.material) formData.set('material', payload.material)

    const arenaId = payload.arena_id || payload.arena || null
    if (arenaId) formData.set('arena', arenaId)

    // Always send a non-null description string; the Item
    // serializer does not allow null here and will otherwise
    // raise a validation error on artefact-create.
    formData.set('description', payload.description != null ? payload.description : '')

    // Preserve the artefact's actual tallyable flag; default false if missing.
    formData.set('tallyable', payload.tallyable ?? false)
    formData.set('storeable', payload.storeable ?? true)
    formData.set('countable', payload.countable ?? false)

    if (payload.unit_name !== undefined && payload.unit_name !== null) {
      formData.set('unit_name', payload.unit_name)
    }
    if (payload.max_unit_count !== undefined && payload.max_unit_count !== null) {
      formData.set('max_unit_count', payload.max_unit_count)
    }
    if (payload.healing_type !== undefined && payload.healing_type !== null) {
      formData.set('healing_type', payload.healing_type)
    }
    if (payload.recovers !== undefined && payload.recovers !== null) {
      formData.set('recovers', payload.recovers)
    }
    if (payload.poison_type !== undefined && payload.poison_type !== null) {
      formData.set('poison_type', payload.poison_type)
    }
    if (payload.pot !== undefined && payload.pot !== null) formData.set('pot', payload.pot)
    if (payload.effect !== undefined && payload.effect !== null) {
      formData.set('effect', payload.effect)
    }
    if (payload.delay !== undefined && payload.delay !== null) {
      formData.set('delay', payload.delay)
    }
    if (payload.damage_dice !== undefined && payload.damage_dice !== null) {
      formData.set('damage_dice', payload.damage_dice)
    }
    if (payload.duration !== undefined && payload.duration !== null) {
      formData.set('duration', payload.duration)
    }
    if (payload.resist !== undefined && payload.resist !== null) {
      formData.set('resist', payload.resist)
    }

    // -----------------------------
    // CharacterItem-level fields
    // -----------------------------
    if (payload.character) formData.set('character', payload.character)
    if (payload.container) formData.set('container', payload.container)
    if (payload.worn_location) formData.set('worn_location', payload.worn_location)
    if (payload.attach_location) formData.set('attach_location', payload.attach_location)
    if (payload.armour_location) formData.set('armour_location', payload.armour_location)

    if (payload.tally_qty !== undefined && payload.tally_qty !== null) {
      formData.set('tally_qty', payload.tally_qty)
    }

    // Always send non-null strings for text fields that the
    // CharacterItemSerializer does not allow to be null.
    formData.set(
      'player_notes',
      payload.player_notes != null ? payload.player_notes : (payload.notes ?? ''),
    )
    formData.set(
      'short_description',
      payload.short_description != null ? payload.short_description : '',
    )

    if (payload.ap !== undefined && payload.ap !== null) formData.set('ap', payload.ap)
    if (payload.hp !== undefined && payload.hp !== null) formData.set('hp', payload.hp)
    if (payload.pwr_storage !== undefined && payload.pwr_storage !== null) {
      formData.set('pwr_storage', payload.pwr_storage)
    }
    if (payload.pwr_storage_cur !== undefined && payload.pwr_storage_cur !== null) {
      formData.set('pwr_storage_cur', payload.pwr_storage_cur)
    }
    if (payload.cur_unit_count !== undefined && payload.cur_unit_count !== null) {
      formData.set('cur_unit_count', payload.cur_unit_count)
    }
    if (payload.held !== undefined && payload.held !== null) formData.set('held', payload.held)
    if (payload.equipped !== undefined && payload.equipped !== null) {
      formData.set('equipped', payload.equipped)
    }

    // NOTE: runes/non_rune_spells are optional and currently managed
    // through their dedicated harnesses; we ignore them here.

    return this_store.dispatch('characters/createCharacterArtefactItem', formData)
  })

  const results = await Promise.all(promises)
  console.log(
    '[RECOVERABLE_ARTEFACT_TRACE] useCreateCharacterArtefactItemsHarness results',
    results.map((result, index) => ({
      index,
      response_id: result?.data?.id ?? null,
      response_name: result?.data?.name ?? null,
      trace_id: changed_items?.[index]?.payload?.id ?? null,
    })),
  )
  return results
}
